import { render, staticRenderFns } from "./CommercialPaper.vue?vue&type=template&id=10361682"
import script from "./CommercialPaper.vue?vue&type=script&lang=js"
export * from "./CommercialPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports